import { rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import { IDashboardProgramResource, IDashboardRecommendedResource } from './types';

const apiDashboard = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getProgrammes: build.query<IDashboardProgramResource[], void>({
      query: () => '/student/home/programmes',
      transformResponse: (response: SuccessApiResponse<IDashboardProgramResource[]>) =>
        response.data,
    }),
    getRecommendedCourses: build.query<IDashboardRecommendedResource[], void>({
      query: () => '/student/home/recommended-courses',
      transformResponse: (response: SuccessApiResponse<IDashboardRecommendedResource[]>) =>
        response.data,
    }),
  }),
});

export const { useGetProgrammesQuery, useGetRecommendedCoursesQuery } = apiDashboard;
